import React from "react";
import { SITE } from "../config/siteConfig";
import { CallButton } from "./PhoneButtons";

// Barre d'appel fixe en bas d'écran (numéro « Sticky Bar »).
export function StickyBar() {
  return (
    <div className="sticky-bar">
      <CallButton phone={SITE.phones.sticky} label="Appeler un conseiller" className="sticky-btn" />
    </div>
  );
}
